import { Tag } from 'antd';
import { companyColors } from 'apps/investment/constants';
import { EyeIcon } from 'lucide-react';
import { booleanCell, linkCell } from 'utils/cell-formatter';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/catalog/fund-distributors' }),
  },
  {
    accessorKey: 'code',
    header: 'Code',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const value = getValue();

      return <Tag color={companyColors[value]}>{value}</Tag>;
    },
  },
  {
    accessorKey: 'logo',
    header: 'Logo',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const logoUrl = getValue();
      return logoUrl ? (
        <img src={logoUrl} alt="Logo" className="size-8 rounded" />
      ) : (
        '-'
      );
    },
  },

  {
    accessorKey: 'short_name',
    header: 'Tên',
  },
  {
    accessorKey: 'name',
    header: 'Tên đầy đủ',
  },
  {
    accessorKey: 'description',
    header: 'Mô tả',
    cell: ({ getValue }) => {
      const value = getValue();
      return value
        ? value.length > 50
          ? `${value.substring(0, 50)}...`
          : value
        : '-';
    },
  },
  {
    accessorKey: 'term_condition_url',
    header: 'T&C link',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const url = getValue();
      return url ? (
        <a href={url} target="_blank" rel="noopener noreferrer">
          <EyeIcon />
        </a>
      ) : (
        '-'
      );
    },
  },

  {
    accessorKey: 'is_default',
    header: 'Mặc định',
    meta: {
      className: 'text-center',
    },
    cell: booleanCell,
  },
  {
    accessorKey: 'is_econtract_required',
    header: 'Yêu cầu econtract',
    meta: {
      className: 'text-center',
    },
    cell: booleanCell,
  },
];
